import {Controller} from "stimulus"

const RELOAD_COALESCE_MS = 300
const RELOAD_INTERVAL_MS = 1000

export default class extends Controller {
    static values = {
        loading: Boolean,
        autoLoadPages: Boolean,
        recommendationsColumnId: String,
        recommendationsTableId: String
    }

    static get targets() {
        return ["wrapper"]
    }

    connect() {
        this.wrapper = $(this.wrapperTarget)
        this.formWrapper = $("#filterrific_filter")
        this.recommendationsList = this.wrapper.find(".recommendations-column-list")
        this.loadMoreRecommendationsButton = this.wrapper.find('.load-more-recommendations-button')
        this.descriptionButton = this.wrapper.find('.recommendations-column-title-description-button')
        this.headerTitle = this.wrapper.find('.recommendations-column-title')
        this.lastReloading = null
        this.scheduledReload = null
        this.displayLoadMoreButton = null

        if(this.loadingValue) {
            this._load_recommendations()
        } else {
            this._find_last_contact_attempt()
        }

        this.wrapper.on('reloadLastContactAttempt', this._find_last_contact_attempt)
        this.wrapper.on('reloadRecommendations', this._reload_recommendations)
        this.descriptionButton.on('click', this._toggle_opened_description)
    }

    disconnect() {
        clearTimeout(this.scheduledReload)
        this.scheduledReload = null
        this.wrapper.unbind('reloadLastContactAttempt')
        this.wrapper.unbind('reloadRecommendations')
    }

    _find_last_contact_attempt = () => {
        let allLastContactAttemptTimes = this.recommendationsList.children().map(function() { return $(this).data('lastContactAttemptTime') } )
        let lastContactAttemptTime = Math.max.apply(Math, allLastContactAttemptTimes)

        this.recommendationsList.children().each(function () {
            if($(this).data('lastContactAttemptTime') === lastContactAttemptTime) {
                $(this).find('.recommendation-table-item-nav').addClass('recommendation-table-item-last-contact-attempt')
                $(this).find('.recommendation-table-item-nav').prop('title', 'W tej kolumnie to polecenie ma ostatnią próbę kontaktu')
                $(this).find('.recommendation-table-item').addClass('recommendation-table-item-last-contact-attempt')
            } else {
                $(this).find('.recommendation-table-item-nav').removeClass('recommendation-table-item-last-contact-attempt')
                $(this).find('.recommendation-table-item-nav').prop('title', '')
                $(this).find('.recommendation-table-item').removeClass('recommendation-table-item-last-contact-attempt')
            }
        })
    }

    // One save broadcasts the same column several times within milliseconds (e.g. contact attempt + recommendation
    // callbacks), and a second change can follow within a second. Coalesce them into one reload at most every
    // RELOAD_INTERVAL ms instead of dropping the later ones - a dropped broadcast left the column stale (#591).
    // `broadcast` is the cable payload (show.html.erb); remember its load-more decision for the deferred reload
    _reload_recommendations = (_event, broadcast) => {
        if(broadcast != null && broadcast.display_load_more_button != null) {
            this.displayLoadMoreButton = broadcast.display_load_more_button
        }

        if(this.scheduledReload != null) {
            console.log('Column reload already scheduled')
            return
        }

        let sinceLastReload = this.lastReloading == null ? Infinity : new Date() - this.lastReloading
        let wait = Math.max(RELOAD_COALESCE_MS, RELOAD_INTERVAL_MS - sinceLastReload)
        console.log('Reloading column in ', wait, 'ms')
        this.scheduledReload = setTimeout(this._perform_reload, wait)
    }

    _perform_reload = () => {
        this.scheduledReload = null
        // a fetch is still running - wait for it rather than drop this change
        if(this.loadingValue) {
            console.log('Column still loading, reloading after it finishes')
            this._reload_recommendations()
            return
        }

        this.lastReloading = new Date();

        console.log('Reload column starting...')
        console.log('Current scroll position is ', window.scrollY)
        this.wrapper.data('beforeReloadingScrollY', window.scrollY)
        if(!this.autoLoadPagesValue) {
            console.log('Fetching column recommendations')
            this._load_recommendations()
        } else {
            console.log('Resetting column...')
            this._reset_recommendations()
            this.loadingValue = false
            this.loadMoreRecommendationsButton.trigger('reload')
            // the reset fades the button in - re-apply the server's decision after it, as the synchronous reload used to
            this._apply_load_more_button_visibility()
        }
    }

    _apply_load_more_button_visibility = () => {
        if(this.displayLoadMoreButton == null) return

        if(this.displayLoadMoreButton) {
            this.loadMoreRecommendationsButton.show()
        } else {
            this.loadMoreRecommendationsButton.hide()
        }
    }

    _reset_recommendations = () => {
        this.recommendationsList.children().remove()
        this.wrapper.find('.loading-spinner').show()
    }

    _load_recommendations = () => {
        this.loadingValue = true;
        this._reset_recommendations()
        Rails.ajax({
            url: window.location.origin + '/recommendations_tables/' + this.recommendationsTableIdValue + '/load_recommendations/' + this.recommendationsColumnIdValue + '?' + this.formWrapper.serialize(),
            type: 'get',
            success: this._show_recommendations,
            // otherwise loadingValue stays true and every later reload waits for this one forever
            error: () => { this.loadingValue = false }
        })
    }

    _show_recommendations = (recommendations) => {
        if(this.loadingValue) {
            this.recommendationsList.append(recommendations.body.innerHTML)
            this.wrapper.find('.loading-spinner').hide()
            this._find_last_contact_attempt();
            this.loadingValue = false;
        }
    }

    fetch_loading_value = () => {
        return this.loadingValue;
    }

    _toggle_opened_description = () => {
        this.headerTitle.toggleClass('opened-description')
        this.descriptionButton.toggleClass('opened-description')
    }
}
